import { apiFetch } from './client';
import type { UserPublic, HandListItem } from '../types/mjai';

export interface UserProfile {
  user: UserPublic;
  hands: HandListItem[];
}

export async function getUserProfile(username: string): Promise<UserProfile> {
  return apiFetch<UserProfile>(`/users/${encodeURIComponent(username)}`);
}
